var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("modal-key-container", {
    attrs: { title: _vm.$t("title") },
    on: { handleClose: _vm.handleClose },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "emd-text",
              { staticClass: "eu-mb_3", attrs: { size: "regular" } },
              [_vm._v(_vm._s(_vm.$t("description")) + " ")]
            ),
            _c("div", { staticClass: "emd-form-group" }, [
              _c("label", {
                staticClass: "emd-label",
                attrs: { for: "secretKey" },
              }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.secretKey.masked_key,
                    expression: "form.secretKey.masked_key",
                  },
                ],
                staticClass: "emd-input",
                attrs: {
                  disabled: "",
                  readonly: "",
                  type: "text",
                  id: "secretKey",
                  name: "secretKey",
                },
                domProps: { value: _vm.form.secretKey.masked_key },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.form.secretKey,
                      "masked_key",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
            _c("password-confirmation", {
              attrs: {
                "has-error": _vm.authError,
                placeholder: _vm.$t("form.password.placeholder"),
                label: "",
              },
              model: {
                value: _vm.form.password,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "password", $$v)
                },
                expression: "form.password",
              },
            }),
            _c(
              "div",
              { staticClass: "emd-form-group" },
              [
                _c("jade-checkbox", {
                  attrs: {
                    id: "checkbox",
                    value: _vm.form.checkbox,
                    label: _vm.$t("form.checkbox"),
                  },
                  on: {
                    "update:value": function ($event) {
                      return _vm.$set(_vm.form, "checkbox", $event)
                    },
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c(
              "emd-button",
              {
                attrs: {
                  color: "danger",
                  "data-testid": "confirm-action",
                  disabled: _vm.computedDisabled,
                },
                on: { click: _vm.handleClick },
              },
              [_vm._v(" " + _vm._s(_vm.$t("form.button.delete")) + " ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }